/* SATORU SASAKI: collection color preview. */
(function () {
  document.addEventListener('click', function (event) {
    var swatch = event.target.closest('.satoru-collection-color');
    if (!swatch) return;
    if (swatch.classList.contains('satoru-collection-color--soldout')) { event.preventDefault(); return; }
    var imageUrl = swatch.getAttribute('data-satoru-variant-image');
    if (!imageUrl) return; // Keep link navigation when no variant image exists.
    var card = swatch.closest('.product-collection');
    if (!card) return;
    var imageLink = card.querySelector('.product-collection__image a[data-js-product-image]');
    var image = imageLink && imageLink.querySelector('img');
    if (!image) return;
    event.preventDefault();
    var selectedUrl = swatch.getAttribute('href');
    var imageContainer = image.closest('.rimage');
    if (imageContainer) {
      imageContainer.querySelectorAll('img').forEach(function (img) {
        img.setAttribute('src', imageUrl);
        img.removeAttribute('srcset');
        img.removeAttribute('data-srcset');
        img.setAttribute('data-master', imageUrl);
      });
    } else {
      image.src = imageUrl;
      image.removeAttribute('srcset');
      image.removeAttribute('data-srcset');
    }
    imageLink.setAttribute('href', selectedUrl);
    card.querySelectorAll('.satoru-collection-color').forEach(function (item) {
      item.classList.toggle('is-selected', item === swatch);
    });
  });
})();
